export default function Section({ links, cis }) {
    const id = links.filter((x) => x.name.toLowerCase().includes("storyboard"))[0].name.replaceAll(" ", "_");

    return (
        <section id={id}>
            <h1> Continuous Improvement Storyboards </h1>
            <div className="cis">
                {cis ? cis.map((x, i) => {
                    return (
                        <div className="storyboard-card" key={i}>
                            <img src={`https://api-als2.nutramax.com/assets/${x.img}`} alt={x.name} />
                            <a href={`https://api-als2.nutramax.com/assets/${x.file}?download`} download target="_blank" rel="noreferrer" > {x.name} </a>
                            <p> {x.summary} </p>
                        </div>
                    )
                }) : null}
            </div>
        </section>
    )
}